import { render, staticRenderFns } from "./TaskRecursionRow.vue?vue&type=template&id=fa77af5a&"
import script from "./TaskRecursionRow.vue?vue&type=script&lang=js&"
export * from "./TaskRecursionRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports